interface DuplicateNamesCounter {
  getNonDuplicatedName(fileName: string): string;
  appendFileNameAndRemainExtension(originalFileName: string, appendingName: string): string;
}

class FileUtil {
  createDuplicateNamesCounter(): DuplicateNamesCounter {
    const duplicatedNamesCounter = {};
    return {
      getNonDuplicatedName(fileName: string): string {
        if (duplicatedNamesCounter[fileName]) {
          duplicatedNamesCounter[fileName] += 1;
          return this.appendFileNameAndRemainExtension(fileName, '_' + (duplicatedNamesCounter[fileName] - 1));
        }
        duplicatedNamesCounter[fileName] = 1;
        return fileName;
      },
      appendFileNameAndRemainExtension(originalFileName: string, appendingName: string): string {
        const parts = originalFileName.split('.');
        const baseName = parts.slice(0, -1).join('.');
        const extension = parts[parts.length - 1];
        if (baseName.length === 0) {
          // folder name
          return `${extension}${appendingName}`;
        }
        return `${baseName}${appendingName}.${extension}`;
      },
    };
  }

  /**
   * Prepares attachments array for processing by organizing them into categories
   * @param attachmentsArray - Array of attachments to prepare
   * @returns Object containing categorized attachments
   */
  prepareAttachments(attachmentsArray: any[]): any {
    const attachments = {
      media: null,
      files: null,
      links: null,
      existingMedia: [],
      attachedSecureDocumentIds: null,
    };

    if (attachmentsArray != null && attachmentsArray.length > 0) {
      for (const att of attachmentsArray) {
        if (att.id == null) {
          if (att.media != null || att.multipartUploadingInfo != null) {
            if (attachments.media == null) {
              attachments.media = [];
            }
            const media = {
              file: att.media.file,
              name: att.name,
              mediaType: att.media ? att.media.mediaType : att.multipartUploadingInfo.mediaType,
              rotationDegree: att.media.rotationDegree != null ? att.media.rotationDegree : 0,
              title: att.media.title,
              description: att.media.description,
              tags: att.media.tags != null ? att.media.tags.map(tag => tag.id) : [],
              albumId: att.media.albumId != null ? att.media.albumId : null,
              sensitivityLevel: att.sensitivityLevel != null ? att.sensitivityLevel : null,
              allowsComments: true,
              multipartUploadingInfo: undefined,
            };
            if (att.media.file.isLargeFile) {
              media.multipartUploadingInfo = att.media.file.multipartUploadingInfo;
            }
            attachments.media.push(media);
          } else if (att.link != null) {
            if (attachments.links == null) {
              attachments.links = [];
            }
            attachments.links.push({
              accessToken: att.link.accessToken,
              externalFileId: att.link.externalFileId,
              service: att.link.service,
              fileName: att.link.fileName,
              parentDriveId: att.link.parentDriveId,
            });
          } else if (att.file != null) {
            if (attachments.files == null) {
              attachments.files = [];
            }
            if (attachments.attachedSecureDocumentIds == null) {
              attachments.attachedSecureDocumentIds = [];
            }
            if (att.file.attachedSecureDocumentId == undefined) {
              attachments.files.push({
                name: att.name,
                file: att.file,
              });
            } else {
              attachments.attachedSecureDocumentIds.push(att.file.attachedSecureDocumentId);
            }
          }
        } else {
          attachments.existingMedia.push(att);
        }
      }
    }

    return attachments;
  }
}

export const fileUtil = new FileUtil();
